import { apiFuns } from "sw-hic";
let api = {
  Setting: apiFuns.genStandard("setting", "/api/md"),
};
export default api;
